import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { StaffDetailsHttpModel } from '../../http/profile/profile-http.models';
import { ErrorResponse } from '../../shared/shared-http.models';

export const StaffDetailsActions = createActionGroup({
  source: 'Staff Details',
  events: {
    'Load Staff Details': emptyProps(),
  },
});

export const StaffDetailsAPIActions = createActionGroup({
  source: 'Staff Details API',
  events: {
    'Loaded Staff Details Successfully': props<{
      staffDetails: StaffDetailsHttpModel;
    }>(),
    'Loaded Staff Details Unsuccessfully': props<{ error: ErrorResponse }>(),
  },
});
